import { render, staticRenderFns } from "./HomePart7.vue?vue&type=template&id=37156940&scoped=true&"
import script from "./HomePart7.vue?vue&type=script&lang=js&"
export * from "./HomePart7.vue?vue&type=script&lang=js&"
import style0 from "./HomePart7.vue?vue&type=style&index=0&id=37156940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37156940",
  null
  
)

export default component.exports